<div *ngIf="isLoading" class="center">
    <mat-spinner class="example-margin" [color]="color"></mat-spinner>
</div>

<div *ngIf="!isLoading" >
    <mat-list>
        @if(teamMessageArray.length === 0){
            <span class="text-color-blue" style="font-size: 20px; margin-left: 10px;">{{ 'ml_151232' | translate }}</span>
        }
        @else {
            @for (teamMessage of teamMessageArray; track teamMessage; let last = $last) {                
                <mat-card  class="example-card mat-card-background-color-white-smoke" (click) = "goToDetail(teamMessage)">
                    <section>
                        <div class="example-label mat-card-background-color-white-smoke" style="height: 78px;">
                            <mat-icon [style.color]="teamMessage.readTime === null ? '#009947' : 'whitesmoke'" aria-hidden="false" 
                            aria-label="Example home icon" fontIcon="circle" style=" font-size: 16px; padding-left: 10px;  padding-top: 10px;"></mat-icon>
                        </div>
                        <div class="example-button-row">
                            <mat-card-header style="padding-top: 2px; padding-left: 8px;">
                                <mat-card-title class="flex-basis-200px" style="font-size: 18px;">
                                    <span>{{ teamMessage.author }}</span>                                
                                </mat-card-title>                            
                                <mat-card-subtitle >{{ teamMessage.title }}</mat-card-subtitle>
                                <mat-card-subtitle >{{ teamMessage.dateTime }}</mat-card-subtitle>                            
                            </mat-card-header>
                        </div>
                    </section>                                                                                                                    
                </mat-card>
            } 
        }               
    </mat-list>
</div>